import React from 'react'
import { MoreVertical } from 'lucide-react'
import {
  Badge, Button, Checkbox,
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from '../../../ui'

// Vista de presentacion, sin fetch propio. gruposNombresDe es un mapa
// jugadorId -> nombres de grupo ya resueltos (nunca UUIDs) que arma el
// orquestador. OJO: no renombrar a "gruposDe" a secas -- planCobertura.js ya
// usa ese nombre para un mapa jugadorId -> [grupoId, ...] (ids, para filtrar
// con .includes(grupoId)); misma forma Record<id, string[]>, semantica
// opuesta. Si algun dia conviven en la misma pantalla con el mismo nombre, un
// intercambio accidental pinta UUIDs en pantalla o rompe el filtro en
// silencio.
// Sin caso vacio propio: el orquestador ya intercepta jugadores.length === 0
// antes de montar esta vista (sabe si es "sin filtros que coincidan" o
// "genuinamente no hay a quien asignar" y lo dice mejor de lo que podriamos
// decir aqui a ciegas).
// `planesDeJugador` (jugadorId -> [{ asignacionId, nombre }]) es lo que antes
// vivia en una segunda lista al pie de la pantalla, "Planes ya asignados". Eran
// dos listas de las mismas personas, filtradas por el mismo buscador: costaba
// entender cual era cual. Ahora el plan que alguien ya tiene se lee en su propia
// fila, y desasignarlo esta en el menu de esa fila.
const VistaJugadores = ({
  jugadores, gruposNombresDe = {}, planId, adeudoDe = new Set(),
  planesDeJugador = {}, onDesasignar,
  promocionesDeJugador = {}, onQuitarPromocion,
  seleccion = new Set(), onToggle,
}) => (
  <ul className="divide-y divide-border">
    {jugadores.map((j) => {
      const suyos = planesDeJugador[j.id] || []
      const promos = promocionesDeJugador[j.id] || []
      const grupos = gruposNombresDe[j.id] || []
      const conAdeudo = adeudoDe.has(j.id)
      const hayMenu = (suyos.length > 0 && onDesasignar) || (promos.length > 0 && onQuitarPromocion)
      return (
        <li
          key={j.id}
          onClick={() => onToggle(j.id)}
          className="flex min-h-11 cursor-pointer items-start gap-3 rounded-md px-1 py-3 hover:bg-muted/50"
        >
          {/* Toda la fila es el area tactil (ux-rules #11); el Checkbox detiene
              la propagacion para no disparar el toggle dos veces. */}
          <div onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={seleccion.has(j.id)}
              onCheckedChange={() => onToggle(j.id)}
              aria-label={`Seleccionar a ${j.nombre_completo}`}
            />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium">
              {j.nombre_completo}
              {j.numero != null && (
                <Badge variant="outline" className="ml-2 text-[10px]">#{j.numero}</Badge>
              )}
            </p>
            <p className="truncate text-xs text-muted-foreground">
              {grupos.length ? grupos.join(', ') : 'Sin grupo'}
            </p>
          </div>
          <div className="flex shrink-0 items-start gap-1">
            <div className="flex flex-col items-end gap-1">
              {suyos.length === 0 ? (
                <Badge variant="outline">Sin plan</Badge>
              ) : (
                suyos.map((p) => (
                  <Badge
                    key={p.asignacionId}
                    variant={p.id === planId ? 'default' : 'secondary'}
                    className="max-w-[11rem] truncate"
                    title={p.id === planId ? `${p.nombre} (el que estas asignando)` : p.nombre}
                  >
                    {p.nombre}
                  </Badge>
                ))
              )}
              {/* Las promociones se distinguen de los planes por el borde: un
                  plan cobra, una promocion descuenta. */}
              {promos.map((p) => (
                <Badge
                  key={p.asignacionId}
                  variant="outline"
                  className="max-w-[11rem] truncate border-dashed"
                  title={`Promocion: ${p.nombre}`}
                >
                  {p.nombre}
                </Badge>
              ))}
              {conAdeudo && <Badge variant="warning">Adeudo</Badge>}
            </div>
            {hayMenu && (
              // Los destructivos van dentro del menu, nunca como icono suelto
              // (ux-rules #10), y con etiqueta explicita: con dos planes hay que
              // poder quitar UNO, no "el plan" a secas.
              <div onClick={(e) => e.stopPropagation()}>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="h-9 w-9 p-0"
                      aria-label={`Acciones de ${j.nombre_completo}`}
                    >
                      <MoreVertical className="h-4 w-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    {onDesasignar && suyos.map((p) => (
                      <DropdownMenuItem
                        key={p.asignacionId}
                        className="text-destructive focus:text-destructive"
                        onClick={() => onDesasignar(p.asignacionId, p.nombre, j.nombre_completo)}
                      >
                        Desasignar "{p.nombre}"
                      </DropdownMenuItem>
                    ))}
                    {onQuitarPromocion && promos.map((p) => (
                      <DropdownMenuItem
                        key={p.asignacionId}
                        className="text-destructive focus:text-destructive"
                        onClick={() => onQuitarPromocion(p.asignacionId, p.nombre, j.nombre_completo)}
                      >
                        Quitar "{p.nombre}"
                      </DropdownMenuItem>
                    ))}
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            )}
          </div>
        </li>
      )
    })}
  </ul>
)

export default VistaJugadores
